<!--
 * @Description: 上传试卷
 * @Author: PF
 * @Date: 2023-09-12 14:46:16
 * @LastEditors: PF
 * @LastEditTime: 2024-08-01 14:04:26
-->
<template>
  <div>
    <el-dialog class="wp80 hp70" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">上传试卷</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" class="hp100" :model="ruleForm" label-width="140px">
        <el-container>
          <el-header class="pl0 pr0">
            <!-- 按钮区域 BEGIN -->
            <el-row>
              <el-col :span="8">
                <el-form-item label="试卷类别" prop="sjlb" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <el-select v-model="ruleForm.sjlb" filterable clearable>
                    <el-option v-for="item in sjlxData.list" :key="item.value" :label="item.name" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.sjlb === sjlxData.zhiDingShiJuan">
              <el-col :span="8">
                <el-form-item label="试卷" prop="sjid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <!-- 单选 BEGIN -->
                  <el-button class="mr10" type="primary" @click="opensjDanTiao=true">选择</el-button>
                  <el-tag class="mr10 mt10" v-if="ruleForm.sjid" closable @close="sjYiChu">{{ruleForm.sjmc}}</el-tag>
                  <!-- 单选 END -->
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="及格分数" prop="jgfs">{{ ruleForm.jgfs }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="建议考试时长(分钟)" prop="jykssc">{{ ruleForm.jykssc }}</el-form-item>
              </el-col>
            </el-row>
            <div v-if="ruleForm.sjlb === sjlxData.shiJuanSuiJiShiTi">
              <el-row v-for="(item, index) in ruleForm.listKcJxdy" :key="index" style="display: flex;justify-content: space-between;align-items: baseline;">
                <el-col :span="6">
                  <div>课程：{{ item.kcmc }}</div>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="起始教学单元" :prop="'listKcJxdy.'+index+'.qsjxdyid'" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-select class="mr10" v-model="item.qsjxdyid" filterable clearable style="width: calc(100% - 44px);" @visible-change="jxdyChange(item.kcid, index)">
                      <el-option v-for="(jxdyItem, jxdyInd) in item.jxdyData" :key="jxdyInd" :label="jxdyItem.jxdybt" :value="jxdyItem.id" />
                    </el-select>
                    <el-button type="primary" link @click="dqObj={kcid:item.kcid, index};openAddJiaoXueDanYuan=true;row={kcid:item.kcid,kcmc:item.kcmc}">添加</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="终止教学单元" :prop="'listKcJxdy.'+index+'.zzjxdyid'" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-select class="mr10" v-model="item.zzjxdyid" filterable clearable style="width: calc(100% - 44px);" @visible-change="jxdyChange(item.kcid, index)">
                      <el-option v-for="(jxdyItem, jxdyInd) in item.jxdyData" :key="jxdyInd" :label="jxdyItem.jxdybt" :value="jxdyItem.id" />
                    </el-select>
                    <el-button type="primary" link @click="dqObj={kcid:item.kcid, index};openAddJiaoXueDanYuan=true;row={kcid:item.kcid,kcmc:item.kcmc}">添加</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="button-box" v-if="ruleForm.sjlb === sjlxData.shiJuanSuiJiShiTi">
              <el-button type="primary" @click="addSti"><span class="iconfont icon-chuangjian"></span>添加题型</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main class="pl0 pt0 pr0 pb0" v-if="ruleForm.sjlb === sjlxData.shiJuanSuiJiShiTi">
            <el-table :data="ruleForm.listStsz" height="100%" border stripe>
              <el-table-column label="序号" type="index" width="55" fixed align="center" />
              <el-table-column label="题型" fixed prop="txid" min-width="150" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-select v-model="scope.row.txid" clearable filterable>
                    <el-option v-for="item in txData" :key="item.id" :label="item.bt" :value="item.id" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="数量" prop="sl" min-width="150" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-input-number v-model="scope.row.sl" :min="0" placeholder="数量" @change="fenZhiChange(scope.row, scope.$index)" />
                </template>
              </el-table-column>
              <el-table-column label="难度" prop="nd" min-width="350" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-input-number v-model="scope.row.ndsj" :min="0" :precision="1" placeholder="难度上界" style="width:150px" />
                  <span class="ml5 mr5">至</span>
                  <el-input-number v-model="scope.row.ndxj" :min="0" :precision="1" placeholder="难度下界" style="width:150px" />
                </template>
              </el-table-column>
              <el-table-column label="每题分数" prop="mtfs" min-width="150" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-input-number v-model="scope.row.mtfs" :min="0" :precision="1" placeholder="每题分数" @change="fenZhiChange(scope.row, scope.$index)" />
                </template>
              </el-table-column>
              <el-table-column label="总分数" prop="zfs" min-width="150" align="center" show-overflow-tooltip />
              <el-table-column label="操作" fixed="right" width="120" align="center">
                <template #default="scope">
                  <el-link :underline="false" type="danger" size="mini" @click="delSti(scope.$index)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-container>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <shijuandantiao v-if="opensjDanTiao" v-model:openDanTiao="opensjDanTiao" @ReturnData="sjReturnData" />
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="initJxdy" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { actionPost, loadSelect, closeWindow, submitForm } from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import { getTiXing } from '@/utils/zidianmeiju'
import shijuandantiao from '@/components/chazhaodaihui/shijuandantiao'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'

const props = defineProps({ openAdd: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openAdd'])

const ruleFormRef = ref(null)
const ruleForm = ref({ listStsz: [], listKcJxdy: [{}] })

// 单选 BEGIN
const opensjDanTiao = ref(false)
const sjReturnData = (data) => {
  ruleForm.value.sjid = data.id
  ruleForm.value.sjmc = data.sjmc
  ruleForm.value.jgfs = data.jgfs
  ruleForm.value.jykssc = data.jykssc
}
const sjYiChu = () => {
  ruleForm.value.sjid = ''
  ruleForm.value.sjmc = ''
}
// 单选 END

// 计算分值
const fenZhiChange = (val, ind) => {
  if (ruleForm.value.listStsz[ind].sl && ruleForm.value.listStsz[ind].mtfs) {
    const sum = Number(ruleForm.value.listStsz[ind].sl) * Number(ruleForm.value.listStsz[ind].mtfs)
    ruleForm.value.listStsz[ind].zfs = sum
  }
}

// 添加试题
const addSti = () => {
  ruleForm.value.listStsz.push({ sl: 1, mtfs: 0, zfs: 0 })
}
// 删除试题
const delSti = (index) => {
  ruleForm.value.listStsz.splice(index, 1)
}

// 添加教学单元
const row = ref()
const openAddJiaoXueDanYuan = ref(false)
const dqObj = ref({}) // 当前位置
const jxdyChange = (kcid, index) => {
  dqObj.value = { kcid, index }
  initJxdy()
}
// 获取教学单元
const initJxdy = () => {
  const o = { url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list', data: { kcid: dqObj.value.kcid, order: 'sx', sort: 'asc' } }
  actionPost(o).then((res) => {
    ruleForm.value.listKcJxdy[dqObj.value.index].jxdyData = res.data
  })
}
// 获取考试科目
const initKaoShiKeMu = () => {
  actionPost({
    url: '/api/v2/jiaowu/kaowukaoshijihua/shijuanzujuandaibanchaxunkaoshikemuid',
    data: { dbsxid: ruleForm.value.dbsxid }
  }).then((res) => {
    if (res.code === 200) {
      keMuChange(res.data.kskmid)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 获取课程
const keMuChange = (val) => {
  const o = { url: '/api/v2/jiaowu/kaowukaoshikemu/kemukechengchaxun', data: { kmid: val, order: 'kch', sort: 'asc' } }
  actionPost(o).then((res) => {
    ruleForm.value.listKcJxdy = res.data.map(item => ({ kcid: item.kcid, kcmc: item.kcmc }))
    initJxdy()
  })
}

const zytxData = ref({ list: [] }) // 题型
const sjlxData = ref({ list: [] }) // 试卷类型
const txData = ref([]) // 题型
const sjData = ref([]) // 试题
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.dbsxid = props.row.id
      zytxData.value = getTiXing()
      initKaoShiKeMu()
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/shijuanleibie', data: sjlxData, loadSuccess: function (res) { ruleForm.value.sjlb = res.data.zhiDingShiJuan } })
      loadSelect({ url: '/api/v2/ziyuanku/shijuan/list', data: sjData })
      loadZiDianSelect('题型', txData)
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.listKcJxdy = ruleForm.value.listKcJxdy.map(item => ({ kcid: item.kcid, qsjxdyid: item.qsjxdyid, zzjxdyid: item.zzjxdyid }))
  submitForm({
    url: '/api/v2/jiaowu/kaowukaoshijihua/shijuanzujuandaiban',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
